"use client";

import styles from "./Author.module.css";

type Props = {
  /** The company name to display */
  company: string;
  /** The company URL to link to */
  url: string;
  /** Test ID for testing */
  testId?: string;
};

export const CompanyLink = ({ company, url, testId }: Props) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.companyLink}
      aria-label={company}
      data-testid={testId}
    >
      {company}
    </a>
  );
};
